import { useLayoutEffect, useRef } from 'react';

// Guarda el último valor en un ref para los callbacks que viven fuera del render (motores WebGL o canvas, timers).
// Se actualiza en un layout effect: escribir ref.current durante el render rompe las reglas del React Compiler.
export default function useLatest(value) {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
